import { LoaderParserPriority } from '@pixi/assets';
import { ExtensionType, extensions, utils } from '@pixi/core';

const formats = ['mp4', 'webm']

const videoLoader = {
  extension: {
    name: "videoLoader",
    priority: LoaderParserPriority.Normal,
    type: ExtensionType.LoadParser,
  },
  test(asset, options, Loader) {
    return !!asset && !!options && formats.includes(options.format);
  },
  async load(asset, options, Loader) {
    const texture = PIXI.Texture.from(options.src, {autoPlay: false});
    const resource = texture.baseTexture.resource;
    resource.autoPlay = false;
    resource.updateFPS = 30;

    await resource._load;
    return texture;
  },

  testParse(asset, options, Loader) {
    return !!asset && !!options && formats.includes(options.format);
  },
  async parse(asset, options, Loader) {
    PIXI.Assets.cache.set(options.alias[0], asset);
    return asset;
  }
}
extensions.add(videoLoader);
